module.exports = __webpack_public_path__ + "files/otterhud_logo.0042a3a392f9837dc688e4ebee817ae3.png";